import type { StringSchema } from 'yup';
import { addMethod, string } from 'yup';

// eslint-disable-next-line func-names
addMethod<StringSchema>(string, 'anyUUID', function () {
  // eslint-disable-next-line no-template-curly-in-string
  return this.test('any-uuid', '${path} must be a valid UUID', (value) => {
    if (!value) return true; // Allow empty values, use .required() to enforce presence
    // Accept nil UUID (all zeros)
    if (
      value === '00000000-0000-4000-8000-000000000000' ||
      value === '00000000-0000-0000-0000-000000000000'
    ) {
      return true;
    }

    const uuidRegex = /^[\da-f]{8}-[\da-f]{4}-[47][\da-f]{3}-[\da-f]{4}-[\da-f]{12}$/i;
    return uuidRegex.test(value);
  });
});

declare module 'yup' {
  interface StringSchema {
    anyUUID(): StringSchema;
  }
}
